import { TextField } from "@mui/material";
import { ElementType, useState } from "react";

interface HelperDescriptionProps {
    description: string;
    handleInputChange: (description: string) => void;
    handleSubmit: (action: 'create' | 'update' | 'delete') => void;
}

export const HelperDescription: ElementType<HelperDescriptionProps> = ({ description, handleInputChange, handleSubmit }) => {
    const [isFocused, setIsFocused] = useState(false);
    const isEmpty = description.length === 0;
    
    // Helper text logic
    const getHelperText = () => {
        if (isEmpty) {
            return "required";
        }
        if (isFocused && description.length > 0) {
            return `${description.length}/255 characters. Press Ctrl+Enter to save.`;
        }
        return ' '; // empty string to maintain spacing
    };

    return (
        <TextField
            label="Description"
            multiline
            rows={2}
            value={description}
            onChange={(e) => handleInputChange(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' && e.ctrlKey) {
                    handleSubmit('update');
                    (e.target as HTMLInputElement).blur();
                }
            }}
            inputProps={{
                maxLength: 255,
            }}
            error={isFocused && isEmpty}
            helperText={getHelperText()}
            sx={{
                flexGrow: 1,
                '& .MuiOutlinedInput-root': {
                    height: '72px',
                },
                '& .MuiOutlinedInput-input': {
                    overflow: 'auto !important',
                    maxHeight: '56px',
                },
                // Keep label gray even in error state
                '& .MuiInputLabel-root.Mui-error': {
                    color: 'text.secondary',
                },
                '& .MuiInputLabel-root.Mui-error.Mui-focused': {
                    color: 'error.main', // Show red when focused and in error state
                },
                // Align helper text with left border
                '& .MuiFormHelperText-root': {
                    marginLeft: 0,
                }
            }}
        />
    );
}